<template>
  <div class="page-slots">
    <header class="slots-header">
      <div class="slots-header-inner">
        <div class="slots-provider-block">
          <span class="slots-provider-eyebrow">{{ $t('home.slot_game') }}</span>
          <h1 class="slots-provider-title">{{ displayProvider }}</h1>
        </div>
        <div class="slots-search-wrap">
          <i class="fas fa-search slots-search-icon" aria-hidden="true"></i>
          <input
            v-model="name"
            type="search"
            class="slots-search"
            :placeholder="$t('home.search_game')"
            autocomplete="off"
            enterkeyhint="search"
          >
        </div>
      </div>
    </header>

    <main class="slots-main">
      <div v-if="displayGames.length === 0" class="slots-empty">
        <i class="fas fa-dice slots-empty-icon" aria-hidden="true"></i>
        <p class="slots-empty-text">{{ emptyMessage }}</p>
      </div>
      <div v-else class="slots-grid">
        <button
          v-for="(game, index) in displayGames"
          :key="`${game.gameID}-${index}`"
          type="button"
          class="slots-card"
          @click="gameInit(game)"
        >
          <div class="slots-card-thumb">
            <GameThumbImg
              :src="imageLinkGenerate(game.gameID, game.provider, game.gameName)"
              :alt="displayGameName(game)"
            />
          </div>
          <div class="slots-card-meta">
            <span class="slots-card-name">{{ displayGameName(game) }}</span>
          </div>
        </button>
      </div>
    </main>

  </div>
</template>
<script>
// import { DropdownMenu, DropdownItem } from 'vant';
import { mapActions } from 'vuex';
import GameThumbImg from '@/components/GameThumbImg.vue';
import {
  getGameUrlFromGamesUrlResponse,
  getGameUrlMissingLaunchBody,
} from '@/utils/gameUrlApiError';
import { showGameUrlErrorDialog, showGameUrlClientError } from '@/utils/showGameUrlErrorDialog';

export default {
  components: { GameThumbImg },

data() {
  return {
    games: [],
    rows: 0,
    provider: 'Pragmatic',
    name: '',
  };
},
computed: {
  displayProvider() {
    return this.$route.query.provider || 'Slots';
  },
  displayGames() {
    const list = Array.isArray(this.games) ? this.games : [];
    const q = (this.name || '').trim().toLowerCase();
    if (!q) return list;
    return list.filter((g) => (g.gameName || '').toLowerCase().includes(q));
  },
  emptyMessage() {
    return this.$store.state.language === 'en'
      ? 'No games match your search.'
      : 'ရှာဖွေမှုနဲ့ ကိုက်ညီသော ဂိမ်းမရှိပါ။';
  },
},
methods: {
  ...mapActions(['fetchUser']),

  /** Strip route / API provider labels from titles (e.g. "PP | Game" → "Game"). */
  displayGameName(game) {
    const raw = (game && game.gameName) ? String(game.gameName).trim() : '';
    if (!raw) return '';
    const candidates = [
      this.$route.query.provider,
      game.provider,
    ]
      .filter(Boolean)
      .map((p) => String(p).trim())
      .filter((p, i, a) => a.indexOf(p) === i);

    let s = raw;
    for (const p of candidates) {
      if (!p) continue;
      const esc = p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      s = s.replace(new RegExp(`^${esc}\\s*[|\\-–—:]\\s*`, 'i'), '');
      s = s.replace(new RegExp(`\\s*[|\\-–—:]\\s*${esc}$`, 'i'), '');
      s = s.replace(new RegExp(`^${esc}\\s+`, 'i'), '');
      s = s.replace(new RegExp(`\\s+${esc}$`, 'i'), '');
      s = s.replace(new RegExp(`^\\[${esc}\\]\\s*`, 'i'), '');
    }
    s = s.trim();
    return s || raw;
  },

slugify(name) {
    let str = name.toLowerCase().trim();

    // 1️⃣ Remove "the" ONLY if it is directly before the LAST word
    str = str.replace(/\bthe\s+([a-z0-9]+)$/i, "$1");

    // 2️⃣ Extract ending number (no hyphen before number)
    const match = str.match(/(\d+)$/);
    let number = "";

    if (match) {
        number = match[1];
        str = str.replace(/\d+$/, "").trim();
    }

    // 3️⃣ Replace spaces with hyphens
    str = str.replace(/\s+/g, "-");

    // 4️⃣ Clean unwanted characters
    str = str.replace(/[^a-z0-9\-]/g, "");

    // 5️⃣ Attach number back
    return number ? str + number : str;
},

    imageLinkGenerate(gameId, type) {
      if (type === 'Jili') {
        // return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
        return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${gameId}.webp`;
      }
      if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
      }
      if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
      }
      if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
      }
      if (type === 'PGSoft') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
      }
      if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      }
      if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
      }
      if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
      }
      if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
      }
      if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
      }
      if (type === 'Buffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
      }
      if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      }
      if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
      }
      if (type === 'Rich88') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${gameId}.webp`;
      }
      if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      }
      if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
      }
      if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
      }
      if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
      }
      if (type === 'BNG'){
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
      }
      if (type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },

  buffaloImage(gameId, type) {
      if (type === 'Jili') {
          // return `https://hot.kingroman999.com/gameIcon3/apiJili/en/JiLi_${gameId}.png`;
          // return`https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/jili/JL_400x540_GameID${gameId}_en-US.webp`;
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
      } if (type === 'Spade') {
          // return `https://hot.onexslot.net/gameIcon3/apiSpadeGame/en/${gameId}.png`;
          // return `https://hot.kingroman999.com/gameIcon3/apiSpadeGame/en/${gameId}.png`;
          return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Fastspin') {
          return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Playstar') {
          return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/playstar/${gameId}.png`;
      } if (type === 'FaChai') {
          // return `https://hot.kingroman999.com/gameIcon3/apiFc/en/fc_${gameId}.png`;
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/fachai/${gameId}.webp`;
      } if (type === 'PGSoft') {
          // return `https://images.9734232.com/TCG_GAME_ICONS/rx2/PG/EN/PG0${gameId}.avif`;
          // return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/${gameId}.webp`;
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
      } if (type === 'JOKER' || type === 'Joker') {
          // return `https://hot.kingroman999.com/gameIcon3/apiJoker/en/${gameId}.png`;
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      } if (type === '5G') {
          return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/5g/${gameId}.png`;
      } if (type === 'KA') {
          // return `https://hot.kingroman999.com/gameIcon3/apiKa/en/${gameId}.png`;
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/ka/${gameId}.webp`;
      } if (type === 'AceWin') {
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/acewin/${gameId}_EN.webp`;
      } if (type === 'JDB') {
          // return `https://hot.onexslot.net/gameIcon3/apiJdb/en/0_${gameId}.png`;
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/jdb/${gameId}.webp`;
      } if (type === 'Buffalo' && gameId == 47) {
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/jili/JL_400x540_GameID${gameId}_en-US.webp`;
      } if (type === 'HotDog'){
          return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      } if (type === 'Rich'){
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/rich/${gameId}.webp`;
      } if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot'){
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      } if (type === 'BTG'){
          return ` https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/btg/${gameId}.webp`;
      } if (type === '2J'){
          return ` https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/2j/${gameId}.webp`;
      } if (type === 'VA'){
          return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/va/${gameId}.webp`;
      }

      // return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pp/${gameId}.webp`;
      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },

  detectMob() {
    let check = false;
    /* eslint-disable */
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a,
        )
                  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4),
                  )
      ) { check = true; }
    }(navigator.userAgent || navigator.vendor || window.opera));
    return check;
  },

  async fetchGames() {
    try {
      // this.$store.commit('setLoading', true);
      const res = await axios.get('/games', {
        params: {
          provider: this.$route.query.provider,
        },
      });
      this.games = res.data.data;

      this.games = this.games.filter((game) => game.gameTypeID.includes('vs'));

      if(this.$route.query.provider === 'Pragmatic'){
        let games = this.games;
        // Cut the last 10 elements
        let lastTenGames = games.slice(-10);

        // Get the remaining elements (excluding the last 10)
        let remainingGames = games.slice(0, -10);

        // Merge the last 10 games at the beginning with the remaining games
        let reorderedGames = lastTenGames.concat(remainingGames);

        // Use the reordered array (update your state if using Vue)
        this.games = reorderedGames;
      }
      // this.$store.commit('setLoading', false);
    } catch (error) {
      // this.$store.commit('setLoading', false);
      console.log(error);
    }
  },

  async gameInit(game) {
    try {
      this.$store.commit('setLoading', true);
      const authUser = await this.fetchUser();
      if (!authUser) {
        this.$router.push('/auth/login');
      }

      let providerID = game.provider;
      // let providerID = this.$route.query.provider;
				// if(providerID === 'Buffalo' && game.gameID == 47) {
				// 	providerID = 'Jili';
				// }
      
      const res = await axios.get('/games/url', {
        params: {
          gameID: game.gameID,
          provider: providerID
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      let gameUrl = getGameUrlFromGamesUrlResponse(res);
      const data = res?.data?.data ?? res?.data ?? {};
      // PGSoft (and some providers) return HTML instead of a URL: render via blob URL
      let rawHtml =
        data.html ??
        res?.data?.html ??
        (typeof res?.data === 'string' && res.data.trimStart().startsWith('<')
          ? res.data
          : null) ??
        (gameUrl && gameUrl.trimStart().startsWith('<') ? gameUrl : null);
      if (!rawHtml) rawHtml = '';
      if (rawHtml && typeof rawHtml === 'string') {
        const blob = new Blob([rawHtml], { type: 'text/html;charset=utf-8' });
        gameUrl = URL.createObjectURL(blob);
      } else if (gameUrl && !gameUrl.startsWith('blob:')) {
        gameUrl += gameUrl.includes('?') ? '&' : '?';
      }

      if (!gameUrl) {
        this.$store.commit('setLoading', false);
        const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
        showGameUrlClientError(getGameUrlMissingLaunchBody(res, lang), lang);
        return;
      }

      // window.open(gameUrl, "_self");
      window.top.location.href = gameUrl;
    

      // const newWindow = window.open(res.data.data.gameUrl, "_self");
      // if (newWindow) {
      //   setTimeout(() => {
      //     this.$store.commit('setLoading', false);
      //   }, 1000);
      // } else {
      //   this.$store.commit('setLoading', true);
      // }
      
      this.$store.commit('setLoading', false);
    } catch (error) {
      this.$store.commit('setLoading', false);
      showGameUrlErrorDialog(
        error,
        this.$store.state.language === 'en' ? 'en' : 'mm',
        this.$store.state.language === 'en'
          ? 'Unable to open the game.'
          : 'ဂိမ်းဖွင့်၍မရပါ။',
      );
    }
  },
},
watch: {
  provider() {
    this.fetchGames();
  },
  '$route.query.provider'() {
    this.name = '';
    this.fetchGames();
  },
},
async mounted() {
  this.$store.commit('setLoading', true);
  await this.fetchGames();
  this.$store.commit('setLoading', false);
},
};
</script>
<style scoped>
.page-slots {
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 6rem;
  background: linear-gradient(
    180deg,
    var(--slot-bg-raised, #11100e) 0%,
    var(--slot-bg-deep, #0a0908) 45%,
    #080706 100%
  );
  -webkit-overflow-scrolling: touch;
}

.slots-header {
  position: sticky;
  top: 0;
  z-index: 20;
  padding: 0.65rem 0.5rem 0.75rem;
  background: linear-gradient(180deg, rgba(14, 12, 10, 0.98) 0%, rgba(10, 9, 8, 0.94) 100%);
  border-bottom: 1px solid var(--slot-brass, rgba(198, 165, 86, 0.45));
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 220, 150, 0.06);
}

.slots-header-inner {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.slots-provider-block {
  text-align: center;
}

.slots-provider-eyebrow {
  display: block;
  font-size: 0.62rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--slot-gold-soft, #b09a5c);
  margin-bottom: 0.2rem;
}

.slots-provider-title {
  font-family: 'Cinzel', 'Times New Roman', serif;
  font-weight: 700;
  font-size: 1.05rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--slot-gold, #d4b968);
  margin: 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  line-height: 1.25;
  word-break: break-word;
}

.slots-search-wrap {
  position: relative;
  width: 100%;
}

.slots-search-icon {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.75rem;
  color: var(--slot-gold-soft, #b09a5c);
  opacity: 0.85;
  pointer-events: none;
}

.slots-search {
  width: 100%;
  border: 1px solid var(--slot-brass, rgba(198, 165, 86, 0.45));
  background: rgba(22, 19, 16, 0.85);
  color: #e8e4dc;
  border-radius: 999px;
  font-size: 0.82rem;
  padding: 0.55rem 0.85rem 0.55rem 2.25rem;
  box-sizing: border-box;
  outline: none;
  box-shadow: inset 0 1px 0 rgba(255, 220, 150, 0.05);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.slots-search::placeholder {
  color: rgba(200, 192, 175, 0.55);
}

.slots-search:focus {
  border-color: var(--slot-brass-bright, rgba(232, 201, 120, 0.85));
  box-shadow:
    inset 0 1px 0 rgba(255, 220, 150, 0.08),
    0 0 0 2px rgba(212, 185, 104, 0.12);
}

.slots-main {
  padding-top: 0.5rem;
  max-width: 100%;
  margin: 0 auto;
}

.slots-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.4rem 0.3rem;
  padding: 0 0.15rem 1rem;
}

.slots-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  -webkit-tap-highlight-color: transparent;
}

.slots-card:active .slots-card-thumb {
  transform: scale(0.97);
}

.slots-card-thumb {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: none;
  background: #0d0c0a;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  transition: transform 0.12s ease, box-shadow 0.15s ease;
  aspect-ratio: 3 / 4;
  min-height: 96px;
}

.slots-card-thumb ::v-deep .game-thumb-wrap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.slots-card-meta {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.4rem 0.1rem 0.35rem;
  min-height: 2.5rem;
}

.slots-card-name {
  font-size: 0.58rem;
  font-weight: 600;
  line-height: 1.25;
  color: #f0ebe3;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.slots-empty {
  text-align: center;
  padding: 3rem 1.5rem 2rem;
}

.slots-empty-icon {
  font-size: 2.25rem;
  color: var(--slot-gold-soft, #b09a5c);
  opacity: 0.35;
  margin-bottom: 0.75rem;
}

.slots-empty-text {
  font-size: 0.88rem;
  color: rgba(200, 192, 175, 0.75);
  margin: 0;
  line-height: 1.5;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
